const actions = {
    GET_PANEL_ACCESS: "GET_PANEL_ACCESS",
    GET_PANEL_ACCESS_SUCCESS: "GET_PANEL_ACCESS_SUCCESS",
    GET_PANEL_ACCESS_FAILED: "GET_PANEL_ACCESS_FAILED",

    RESET_MESSAGE: "RESET_MESSAGE",

    UPDATE_PANEL_ACCESS: "UPDATE_PANEL_ACCESS",
    UPDATE_PANEL_ACCESS_SUCCESS: "UPDATE_PANEL_ACCESS_SUCCESS",
    UPDATE_PANEL_ACCESS_FAILED: "UPDATE_PANEL_ACCESS_FAILED",


    getPanelAccess: (data) => ({
        type: actions.GET_PANEL_ACCESS,
        payload: { data },
    }),

    getPanelAccessSuccess: (data) => ({
        type: actions.GET_PANEL_ACCESS_SUCCESS,
        payload: { data },
    }),

    getPanelAccessError: (error) => ({
        type: actions.GET_PANEL_ACCESS_FAILED,
        error,
    }),

    resetMessage: () => ({
        type: actions.RESET_MESSAGE,
    }),

     updatePanelAccess: (data) => ({
        type: actions.UPDATE_PANEL_ACCESS,
        payload: { data },
    }),

    updatePanelAccessSuccess: (message) => ({
        type: actions.UPDATE_PANEL_ACCESS_SUCCESS,
        payload: { message },
    }),

    updatePanelAccessError: (error) => ({
        type: actions.UPDATE_PANEL_ACCESS_FAILED,
        error,
    }),
};

export default actions;